import { SET_SELECTED_MASS_ID } from '../../actions/massesActions/massesActions';

import { getInitialState } from './initialState';

const initialState = getInitialState(false);

const massesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'masses/saveData':
      return {
        ...state,
        masses: action.payload,
      };

    case SET_SELECTED_MASS_ID:
      return {
        ...state,
        selectedMassId: action.payload,
      };

    default:
      return state;
  }
};

export default massesReducer;
